export default __webpack_public_path__ + "static/media/pt.12b7f019.svg";